<template>
  <div>
    <div>
      <el-dialog  id="register-dialog"
        :visible.sync="dialogVisible"
        width="425px"
        :close-on-click-modal="false"
        :before-close="handleClose"
        :lock-scroll="false"
        :append-to-body="true"
      >
        <el-form
          :rules="rules"
          ref="registerForm"
          :model="form"
          status-icon
          size="medium"
          style="width: 310px; margin: 0 auto"
        >
          <el-row style="margin-bottom: 25px">
            <el-col :span="12">
              <span class="login-title">欢迎注册</span>
            </el-col>
            <el-col :span="12" style="padding-top: 5px; text-align: right">
              <span style="color: #999999; font-weight: 400">已有账号？</span>
              <span
                @click="gotologin()"
                style="cursor: pointer; color: #2c79cb; font-weight: 400"
                >去登录</span
              >
            </el-col>
          </el-row>
            <el-form-item prop="mobile">
            <el-input
              placeholder="填写你的手机号码"
              v-model="form.mobile"
            ></el-input>
          </el-form-item>
          <el-form-item prop="registervCode">
            <p class="input-item" style="margin-top: 0">
              <el-input
                placeholder="短信验证码"
                v-model="form.registervCode"
                class="input-code"
              ></el-input>
              <el-button
                  v-if="registerMessageCoolDown>0"
                  size="small"
                  type="primary"
                  disabled
                  style="height:38px;width:135px; font-size:14px;border-top-left-radius:0;border-bottom-left-radius:0;"
                >({{ registerMessageCoolDown }})秒</el-button>
                <el-button
                  v-else
                  size="small"
                  type="primary"
                  @click="sendVCode"
                  style="height:38px;width:135px;border-top-left-radius:0;border-bottom-left-radius:0;"
                >获取验证码</el-button>
            </p>
          </el-form-item>
            <el-form-item prop="username">
            <el-input
              placeholder="填写你的真实姓名"
              v-model="form.username"
            ></el-input>
          </el-form-item>

          <el-form-item prop="certType">                
            <el-select
              v-model="form.certType"
              placeholder="请选择证件类型"
              class="input-item"
            >
              <el-option
                v-for="item in certTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="certNo">
            <el-input
              placeholder="请输入证件号码"
              v-model="form.certNo"
              maxlength="18"
            ></el-input>
          </el-form-item>

          <el-form-item prop="registerpassword">
            <el-input placeholder="请设置登录密码" type="password" v-model="form.registerpassword"></el-input>
          </el-form-item>
          <el-form-item prop="comfirmPassword">
            <el-input placeholder="请确认登录密码" type="password" v-model="form.comfirmPassword"></el-input>
          </el-form-item>              
          <el-form-item prop="registercaptcha">
            <p class="input-item">
              <el-input
                placeholder="请输入验证码"
                class="input-code"
                v-model="form.registercaptcha"
              ></el-input>
              <canvas
                id="canvas"
                ref="canvas"
                width="100"
                height="36"
                @click="genarateCode"
                style="border: 1px solid #ccc; border-radius: 5px;border-top-left-radius:0;border-bottom-left-radius:0"
              ></canvas>
            </p>
          </el-form-item>
          <span class="dialog-footer">
            <el-button type="primary" v-on:click="onSubmit('registerForm')"
              >注 册</el-button>
          </span>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// 引用示例的js文件
import { post, getToken } from "@/api/common/index";
import { drawCaptcha } from "@/helper/utils";
import { isMobile, isPassWord, isIdCardNo } from "@/helper/validate";
import CryptoJS from "crypto-js";

export default {
  name: "Register",
  inject: ["reload", "switchLoginOrRegister"],
  data() {
    return {
      shownum: [],
      form: {
        certType: "",
        certNo: "",
        username: "",
        mobile: "",
        registerpassword: "",
        comfirmPassword: "",
        registervCode: "",
        registercaptcha: ""        
      },
      certTypeList: [
        {
          label: "身份证",
          value: 0,
        },
        {
          label: "护照",
          value: 1,
        },
      ],
      // 表单验证，需要在 el-form-item 元素中增加 prop 属性
      rules: {
        certType: [
          { required: true, message: "证件类型不可为空", trigger: "change" },
        ],
        certNo: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("证件号码不可为空"));
              } else if (this.form.certType === 0 && !isIdCardNo(value)) {
                callback(new Error("请填写正确的身份证号码"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: "姓名不可为空",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("手机号码不可为空"));
              } else if (!isMobile(value)) {
                callback(new Error("手机号码格式不正确"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        registerpassword: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("密码不可为空"));
              } else if (!isPassWord(value)) {
                callback(
                  new Error("密码不能少于6位，且包含大写字母、小写字母、数字")
                );
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        comfirmPassword: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("确认密码不可为空"));
              } else if (!isPassWord(value)) {
                callback(
                  new Error(
                    "确认密码不能少于6位，且包含大写字母、小写字母、数字"
                  )
                );
              } else if (
                this.form.registerpassword.length > 0 &&
                this.form.registerpassword !== value
              ) {
                callback(new Error("确认密码与密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        registercaptcha: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              let num = this.shownum.join("").toLowerCase();
              if (!value) {
                callback(new Error("验证码不可为空"));
              } else if (value.toLowerCase() !== num) {
                callback(new Error("验证码输入不正确"));
              }

              callback();
            },
            trigger: "blur",
          },
        ],

        registervCode: [
          {
            required: true,
            message: "短信验证码不可为空",
            trigger: "blur",
          },
        ],
      },

      // 对话框显示和隐藏
      dialogVisible: true,
      registerMessageCoolDown: 0
    };
  },
  methods: {
    onSubmit(formName) {      
      // 为表单绑定验证功能
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('请确认姓名、证件号码填写无误，注册后不可修改！', '提示', {
              confirmButtonText: '我已确认无误',
              cancelButtonText: '我再看看',
              type:'warning',
              center:true
          }).then(()=>{
            var name = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.form.username), CryptoJS.enc.Utf8.parse("1234567890ABCDEF"),{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7}).ciphertext.toString().toUpperCase();
            var certNo = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.form.certNo), CryptoJS.enc.Utf8.parse("1234567890ABCDEF"),{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7}).ciphertext.toString().toUpperCase();
            var mobile = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.form.mobile), CryptoJS.enc.Utf8.parse("1234567890ABCDEF"),{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7}).ciphertext.toString().toUpperCase();
            var password = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.form.registerpassword), CryptoJS.enc.Utf8.parse("1234567890ABCDEF"),{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7}).ciphertext.toString().toUpperCase();
            var verifyCode = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.form.registervCode), CryptoJS.enc.Utf8.parse("1234567890ABCDEF"),{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7}).ciphertext.toString().toUpperCase();
            
            post("/api/user/register", {
              certType: this.form.certType,
              certNo: certNo,
              mobile: mobile,
              password: password,
              name: name,
              verifyCode: verifyCode,
            })
              .then(
                () => {
                  // 注册成功后，获取一下Token实现登录
                  // 这里使用手机号+验证码请求登录
                  getToken({
                    username: mobile,
                    password: verifyCode,
                    loginType: 1
                  })
                    .then(() => {
                      // 登陆成功后，执行页面跳转
                      var that = this;
                      that.$message({
                        message: "注册成功，正在跳转到个人中心",
                        type: "success",
                      });
                      that.dialogVisible = false;
                      that.$router.push({ path: "/User/Index" });
                      that.reload();
                    })
                    .catch((error) => {
                      this.$message({
                        message: "登录失败，" + error,
                        type: "error",
                      });
                      drawCaptcha(this.shownum, this.$refs.canvas);
                    });
                },
                (err) => {
                  // success是false的
                  this.$message({
                    message: "注册失败，" + err,
                    type: "error",
                  });
                }
              )
              .catch((error) => {
                this.$message({
                  message: "注册失败，" + error,
                  type: "error",
                });
              });
          });          
        }
      }); 
    },
    handleClose: function (done) {
      done();
      this.$refs["registerForm"].clearValidate();
    },
    genarateCode() {
      drawCaptcha(this.shownum, this.$refs.canvas);
    },
    sendVCode() {
      // 发送手机验证码
      if (!this.form.mobile || !isMobile(this.form.mobile)) {
        this.$message({message:"请填写正确的手机号码！",type:"error"});
        return;
      }

      post("/api/common/send_verify_code", {
        mobile: this.form.mobile,
        codeType: 0,
      }).then(
        (res) => {
          if (res.success) {
            this.registerMessageCoolDown = 60;
            var vue = this;
            var inter1 = setInterval(function () {
              vue.registerMessageCoolDown = vue.registerMessageCoolDown - 1;
              localStorage.setItem(
                "lgwx_registerMessageCoolDown",
                vue.registerMessageCoolDown
              );
              if (vue.registerMessageCoolDown === 0) {
                clearInterval(inter1);
              }
            }, 1000);
          }
        },
        (reason) => {
          if (reason) {
            this.$message({
              message: reason,
              type: "error",
            });
          }
        }
      );
    },
    gotologin() {
      this.switchLoginOrRegister(0);
      this.$refs["registerForm"].clearValidate();
    },
  },
  mounted() {
    var vm = this;
    setTimeout(function () {
      drawCaptcha(vm.shownum, vm.$refs.canvas);
    }, 300);
  },
};
</script>

<style lang="scss">
#register-dialog .login-title {
  text-align: left;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
}

#register-dialog .input-item {
  display: flex;
  flex-shrink: 0;
  
  width: 100%;
  position: relative;
  box-sizing: border-box;
}
#register-dialog .dialog-footer .el-button {
  width: 100%;
  height: 50px;
  background:#2c79cb;
  font-size: 16px;
}

// #register-dialog .el-input /deep/ .el-input__inner {
//   height: 30px;
// }

#register-dialog .input-code /deep/ .el-input__inner{
  border-top-right-radius:0;
  border-bottom-right-radius:0
}

</style>